<script setup>
import { ref, computed, inject } from 'vue';
import { dateToTimeString } from '../../../libs/dates';
import SelectorTurno from './SelectorTurno.vue';
import FormularioVariacion from './FormularioVariacion.vue';

const I18n = inject('I18n');

const props = defineProps({
  // Array de objetos con id de inscripcion y turno_id
  inscripcionesTurno: { type: Array, required: true },
  actionUrl: { type: String, required: true },
});

const turnoSeleccionado = ref({});

const paramsTurnos = computed(() => {
  return {
    id: props.inscripcionesTurno.map((e) => e.turno_id),
  };
});

const idInscripcion = computed(() => {
  const inscripcion = props.inscripcionesTurno.find(
    (e) => e.turno_id === turnoSeleccionado.value.id,
  );
  return inscripcion ? inscripcion.id : undefined;
});

const cabeceraVariacion = computed(() => {
  const texto = `
    ${turnoSeleccionado.value.ruta?.nombre}
    ${turnoSeleccionado.value.nombre}
    ${dateToTimeString(turnoSeleccionado.value.hora)}
  `;
  return I18n.t('variacion_para', { texto });
});
</script>

<template>
  <div class="row">
    <div v-if="!turnoSeleccionado.id" class="col-md-12">
      <selector-turno
        v-model="turnoSeleccionado"
        :params-turnos="paramsTurnos"
        sort-by="hora"
      >
      </selector-turno>
    </div>
    <transition enter-active-class="animated fadeIn">
      <div v-if="turnoSeleccionado.id" class="col-md-12">
        <h3 class="m-b-lg text-center">
          {{ cabeceraVariacion }}
        </h3>
        <formulario-variacion
          :action-url="actionUrl"
          :inscripcion-id="idInscripcion"
          :turno-id="turnoSeleccionado.id"
          :tipos-permitidos="['ausencia', 'cambio_parada']"
        />
      </div>
    </transition>
  </div>
</template>
